module.exports = __webpack_public_path__ + "img/construction-outline_2.1d1f8794.svg";